"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActiveLottery = void 0;
var play_api_1 = require("@l2p/play-api");
var react_1 = require("react");
var useLotteries_1 = require("./useLotteries");
var useActiveLottery = function (_a) {
    var slug = _a.slug;
    var _b = (0, useLotteries_1.useLotteries)(), data = _b.data, isLoading = _b.isLoading, isValidating = _b.isValidating, error = _b.error;
    return (0, react_1.useMemo)(function () { return ({
        data: (data === null || data === void 0 ? void 0 : data.find(function (lottery) {
            var _a;
            return ((_a = lottery === null || lottery === void 0 ? void 0 : lottery.baseLottery) === null || _a === void 0 ? void 0 : _a.slug) === slug &&
                lottery.status === play_api_1.LotteryStatusEnum.Active;
        })) || null,
        isLoading: isLoading,
        isValidating: isValidating,
        error: error,
    }); }, [data, isLoading, isValidating, error, slug]);
};
exports.useActiveLottery = useActiveLottery;
